import { defineRouting } from "next-intl/routing";

import { countriesType } from "../lib/types";

import { pathnames } from "./pathnames";

export { pathnames };

export const siteLocales = process.env.SITE_LOCALES?.split(
  ",",
) as countriesType[];
export const allLocales = process.env.LOCALES?.split(",") as countriesType[];
export const defaultSiteLocale = (process.env.DEFAULT_LOCALE ||
  "sv") as countriesType;

// Every unmatched top-level path falls into the app/[locale] dynamic segment,
// so the segment value has to be checked before it is used: an unvalidated
// one renders the homepage with a 200 (a soft 404) and an invalid `lang`
// attribute (`<html lang="foobar.txt">`, a WCAG 3.1.1 failure). SITE_LOCALES is
// inlined at build time (see the `env` block in next.config.js), so this reads
// no runtime data and keeps the caller prerenderable under cacheComponents.
export const isSiteLocale = (locale: string): locale is countriesType =>
  (siteLocales ?? []).includes(locale as countriesType);

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: siteLocales,

  // Used when no locale matches
  defaultLocale: defaultSiteLocale,
  localePrefix: "as-needed",
  localeDetection: false,
  // Disable the locale cookie to avoid security concerns (HttpOnly/Secure flags)
  // Since localeDetection is false and locale is determined from URL, cookie is not needed
  localeCookie: false,
  pathnames,
});

// The navigation wrappers (Link etc.) live in ./navigation - this module is
// imported by proxy.ts (middleware), and createNavigation pulls in the
// request config, whose next/root-params import is app-directory-only.
